import { useEffect, useState } from 'react';
import { Input } from 'antd';

export default function SearchBox({
	all,
	setshow,
	name,
	setFilter = () => { },
	filterKey,
}) {
	const [text, setText] = useState('');

	useEffect(() => {
		if (all?.length && text.length) {
			let filtered = all.filter((f) =>
				`${f.title}`.toLowerCase().includes(text.toLowerCase())
			);
			setshow(filtered);
		} else {
			setshow(all);
		}
	}, [all, text]);

	const onSearch = (e) => {
		setText(e.target.value);
		setFilter((prev) => {
			return { ...prev, [filterKey]: e.target.value };
		});
	};

	return (
		<Input value={text} placeholder={name} onChange={onSearch} />
	)
}
